import React, { useEffect, useState, useRef } from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import placeholderImage from '../../../assets/images/ourculture/people-talking.png';

const sections = [
  {
    image: placeholderImage,
    title: "Și eu am trecut prin asta, și chiar mai rău...",
    paragraphs: [
      `Când am început să investesc, nu aveam aproape deloc cunoștințe. Nu știam în ce pot investi sau cum să analizez o oportunitate. Așa că am făcut greșeli costisitoare încă de la început. Chiar și cele mai reușite investiții ale mele, cum ar fi cele din sectorul imobiliar, mi-au adus randamente modeste. De ce? Pentru ca am vândut proprietăți valoroase pe baza unor zvonuri “o sa cadă piața”. Nu știam în care ciclu imobiliar mă aflam și am luat decizii impulsive. În zone mai riscante, cum sunt tradingul sau criptomonedele, am pierdut toți banii. Pur și simplu nu înțelegeam cum funcționează aceste piețe si am intrat nepregatită. Pe măsura ce investeam, cei din jurul meu au început să-mi propună tot felul de “oportunități” care promiteau că o să mă îmbogățească “peste noapte”. Nu știam cum să verific proiectele și m-am bazat exclusiv pe încredere. Rezultatul? Am pierdut sume mari de bani în proiecte nesigure sau chiar scam-uri. Într-un punct, m-am oprit. Aveam datorii, eram epuizată psihic și simțeam că nu mai puteam continua așa.. Tot ce câștigasem în 1-2 ani muncind, se evaporase în doar câteva luni. N-aveam cu cine vorbi. N-aveam cui să cer ajutor. Așa că am luat singură o decizie ferma: să nu mai ajung niciodată atât de jos. Am început să-mi achit datoriile și să investesc, pentru prima dată, în ce contează cu adevărat: educația mea financiară, mindsetul meu și oamenii cu care mă înconjor. M-am antrenat să gândesc ca un investitor, să iau decizii raționale, să analizez și să construiesc strategii clare, nu să alerg după „noroc” sau promisiuni goale.`,
    ]
  },
  {
    image: placeholderImage,
    title: "",
    paragraphs: [
      `Pas cu pas, am revenit pe profit. Am început să investesc cu încredere, pe baza unor metodologii, și să văd rezultate reale. Dar poate cel mai important lucru a fost altul: Mi-am promis că niciun investitor – indiferent dacă e la început sau are deja experiență – nu trebuie să treacă singur prin incertitudine, pierderi și confuzie. Așa s-a născut Academillion. … din dorința de a crea o comunitate reală, în care să găsești sprijin, claritate și know-how de la investitori activi. Un loc în care iei decizii informate, nu instinctive. Și unde randamentele tale nu sunt un noroc, ci o consecință a unei strategii clare și asumate. Dacă ar fi mers să înveți singur, ai fi avut deja rezultatele pe care le vrei. Dar adevărul e că încă ești aici, încă cauți soluții și încă plătești, doar că nu conștientizezi… plătești prin timp pierdut, oportunități ratate și bani aruncați pe decizii luate pe ghicite. Adevărul? Nimeni nu vine să te salveze. Ori intri în cercul celor care știu ce fac, ori accepți că vei rămâne exact unde ești acum. Alegerea e simplă. Doar să fii sincer cu tine când o faci.`,
    ]
  }
];


const SolutionSection = () => {
    return (
        <>
        <Box
            sx={{
                backgroundColor: '#262626',
                color: 'white',
                textAlign: 'center',
                position: 'relative',
                paddingTop: { xs: 2, xxl: 6},
                paddingBottom: { xs: 2, xxl: 6},
                px: 1
            }}
        >
            <Box
                sx={{
                    width: { xs: "100%", xxl: "70%" },
                    margin: "0 auto"
                }}
            >
                <Typography
                    variant="h2"
                    sx={{
                        fontWeight: 'bold',
                        lineHeight: 1.5,
                        fontSize: { xs: "20px", xxl: "36px" },
                        color: '#20defa',
                        mt: { xs: 2, xxl: 0 }
                    }}
                >
                    Fii sincer...
                </Typography>

                <Typography
                    variant="subtitle1"
                    sx={{
                        color: '#fff',
                        fontWeight: 500, 
                        fontSize: { xs: "14px", xxl: "21px" }, 
                        lineHeight: "28px", 
                        letterSpacing: "normal", 
                    }}
                >
                    ...și tu ai intrat în investiții cu 0 cunoștine?
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1.5,
                        py: { xs: 3, xxl: 4 },
                        alignItems: 'center',
                    }}
                >
                    {[
                        "Ai bagat bani în proiecte doar pentru că „toată lumea o făcea” și ți-a fost frică să nu pierzi trenul.",
                        "Ai lichidat proprietăți valoroase doar pentru că ai auzit ca „o să cadă piața”.",
                        "Ai vrut să analizezi corect o oportunitate, dar nu ai avut o metodologie clară.",
                    ].map((text, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                        <HighlightOffIcon sx={{ color: "#20defa", fontSize: "42px", mr: 1 }} />
                        <Typography
                            variant="subtitle2"
                            sx={{
                            color: '#fff',
                            fontWeight: 500,
                            fontSize: { xs: "14px", xxl: "21px" },
                            lineHeight: "28px",
                            letterSpacing: "normal",
                            }}
                        >
                            {text}
                        </Typography>
                        </Box>
                    ))}
                </Box>

                <Typography
                    variant="subtitle1"
                    sx={{
                        color: '#fff',
                        fontWeight: 500, 
                        fontSize: { xs: "14px", xxl: "21px" }, 
                        lineHeight: "28px", 
                        letterSpacing: "normal", 
                    }}
                >
                    ...și tu te-ai lăsat dus de emoții și frica de a pierde oportunități?
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1.5,
                        py: { xs: 3, xxl: 4 },
                        alignItems: 'center',
                    }}
                >
                    {[
                        "Ai investit dupa zvonuri primite de la oameni care nici măcar nu erau investitori.",
                        "Ai crezut că te poți imbogăți rapid, dar ai ajuns să pierzi tot ce ai agonisit ani de zile.",
                        "Te-ai aruncat în proiecte nesigure pentru că îți promiteau randamente de de 10X “peste noapte”.",
                    ].map((text, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                        <HighlightOffIcon sx={{ color: "#20defa", fontSize: "42px", mr: 1 }} />
                        <Typography
                            variant="subtitle2"
                            sx={{
                            color: '#fff',
                            fontWeight: 500,
                            fontSize: { xs: "14px", xxl: "21px" },
                            lineHeight: "28px",
                            letterSpacing: "normal",
                            }}
                        >
                            {text}
                        </Typography>
                        </Box>
                    ))}
                </Box>

                <Typography
                    variant="subtitle1"
                    sx={{
                        color: '#fff',
                        fontWeight: 500, 
                        fontSize: { xs: "14px", xxl: "21px" }, 
                        lineHeight: "28px", 
                        letterSpacing: "normal", 
                    }}
                >
                    ...și tu ți-ai dat seama că nu aveai mindset-ul potrivit?
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1.5,
                        py: { xs: 3, xxl: 4 },
                        alignItems: 'center',
                    }}
                >
                    {[
                        "Ai simtit ca ți-ai bătut joc de munca ta pentru că ai pierdut bani.",
                        "Ai rămas pe 0 sau chiar cu datorii și te-ai simțit blocat.",
                        "Ai simtit neîncredere, rușine, furie față de tine și cei din jur.",
                    ].map((text, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                        <HighlightOffIcon sx={{ color: "#20defa", fontSize: "42px", mr: 1 }} />
                        <Typography
                            variant="subtitle2"
                            sx={{
                            color: '#fff',
                            fontWeight: 500,
                            fontSize: { xs: "14px", xxl: "21px" },
                            lineHeight: "28px",
                            letterSpacing: "normal",
                            }}
                        >
                            {text}
                        </Typography>
                        </Box>
                    ))}
                </Box>

                <Typography
                    variant="subtitle1"
                    sx={{
                        color: '#fff',
                        fontWeight: 500, 
                        fontSize: { xs: "14px", xxl: "21px" }, 
                        lineHeight: "28px", 
                        letterSpacing: "normal", 
                    }}
                >
                    ...și tu te-ai simțit izolat, fără oameni pe care să te bazezi?
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1.5,
                        py: { xs: 3, xxl: 4 },
                        alignItems: 'center',
                    }}
                >
                    {[
                        "Ai simtit că ai ajuns la fundul sacului și nu ai cu cine să vorbești despre asta.",
                        "Ai simțit ca ești singur.",
                        "Nu ți-a aratat nimeni cum să eviți capcanele și să vezi oportunitățile reale.",
                    ].map((text, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                        <HighlightOffIcon sx={{ color: "#20defa", fontSize: "42px", mr: 1 }} />
                        <Typography
                            variant="subtitle2"
                            sx={{
                            color: '#fff',
                            fontWeight: 500,
                            fontSize: { xs: "14px", xxl: "21px" },
                            lineHeight: "28px",
                            letterSpacing: "normal",
                            }}
                        >
                            {text}
                        </Typography>
                        </Box>
                    ))}
                </Box>

                <Typography
                    variant="h2"
                    sx={{
                        fontWeight: 'bold',
                        lineHeight: 1.5,
                        fontSize: { xs: "20px", xxl: "36px" },
                        color: '#20defa',
                        paddingTop: { xs: 2, xxl: 2 }
                    }}
                >
                    Adevărul e că banii nu se pierd doar din lipsă de informații.
                </Typography>

                <Box
                    sx={{
                        backgroundColor: '#fff',
                        borderRadius: 3, // 24px if using theme.spacing(3)
                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                        padding: 3,
                        //maxWidth: { xs: 300, xxl: 450 },
                        maxWidth: { xs: 300, xxl: 700 },
                        textAlign: 'center',
                        mx: 'auto',
                        mt: { xs: 2, xxl: 4 }
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{ fontWeight: 'bold', color: '#0a2d7c', mb: 1 }}
                    >
                        
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{ 
                            color: '#333',
                            fontSize: { xs: "14px", xxl: "21px" }, 
                            lineHeight: 1.5 
                        }}
                    >
                        Se pierd pentru că nu ai avut niciodată pe cineva lângă tine care să îți arate exact ce să faci și ce să eviți. Iar singur, în lumea investițiilor, plătești scump fiecare greșeală. De aceea, în loc să mai mergi pe drumuri pe care nu le cunoști, mai bine te alături unei comunități care deja știe traseul. Cu oameni care au făcut greșelile, au plătit prețul și acum știu exact cum se câștigă. Iar tu, de data asta, poți să înveți pe experiențele lor, nu pe ale tale.
                    </Typography>
                </Box>

                {/* <Box 
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', xxl: 'row' },
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 1,
                        paddingTop: { xs: 4, xxl: 6 },
                        paddingBottom: { xs: 3, xxl: 0 }
                    }}
                >
                    <Box 
                        sx={{ 
                            flex: 1,
                            maxWidth: { xs: "100%", xxl: "60%" }, 
                            zIndex: 2, 
                            position: "relative", 
                            color: "#fff",
                            textAlign: { xs: "center", xxl: "left" },
                            mb: { xs: 4, xxl: 0 }
                        }}
                    >
                        <Typography
                            variant="h2"
                            sx={{
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: { xs: "20px", xxl: "36px" },
                                mb: { xs: 3, xxl: 6 },
                                paddingRight: { xs: "10px", xxl: "0" },
                            }}
                        >
                            Și eu am trecut prin asta, <br /> si chiar mai rău...
                        </Typography>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                fontSize: { xs: "14px", xxl: "21px" }, 
                            }}
                        >
                            Când am început să investesc, nu aveam aproape deloc cunoștințe. Nu știam în ce pot investi sau cum să analizez o oportunitate. Așa că am făcut greșeli costisitoare încă de la început.
                            Chiar și cele mai reușite investiții ale mele, cum ar fi cele din sectorul imobiliar, mi-au adus randamente modeste. De ce? Pentru ca am vândut proprietăți valoroase pe baza unor zvonuri “o sa cadă piața”. Nu știam în care ciclu imobiliar mă aflam și am luat decizii impulsive.
                            În zone mai riscante, cum sunt tradingul sau criptomonedele, am pierdut toți banii. Pur și simplu nu înțelegeam cum funcționează aceste piețe si am intrat nepregatită.
                            Pe măsura ce investeam, cei din jurul meu au început să-mi propună tot felul de “oportunități” care promiteau că o să mă îmbogățească “peste noapte”.  Nu știam cum să verific proiectele și m-am bazat exclusiv pe încredere. Rezultatul? Am pierdut sume mari de bani în proiecte nesigure sau chiar scam-uri. 
                            Într-un punct, m-am oprit. Aveam datorii, eram epuizată psihic și simțeam că nu mai puteam continua așa.. Tot ce câștigasem în 1-2 ani muncind, se evaporase în doar câteva luni.
                            N-aveam cu cine vorbi. N-aveam cui să cer ajutor. Așa că am luat singură o decizie ferma: să nu mai ajung niciodată atât de jos.
                            Am început să-mi achit datoriile și să investesc, pentru prima dată, în ce contează cu adevărat: educația mea financiară, mindsetul meu și oamenii cu care mă înconjor. M-am antrenat să gândesc ca un investitor, să iau decizii raționale, să analizez și să construiesc strategii clare, nu să alerg după „noroc” sau promisiuni goale.
                        </Typography>

                        <Typography
                            variant="subtitle2"
                            sx={{
                                fontSize: { xs: "14px", xxl: "21px" }, 
                            }}
                        >
                            Pas cu pas, am revenit pe profit. Am început să investesc cu încredere, pe baza unor metodologii, și să văd rezultate reale.
                            Dar poate cel mai important lucru a fost altul:
                            Mi-am promis că niciun investitor – indiferent dacă e la început sau are deja experiență – nu trebuie să treacă singur prin incertitudine, pierderi și confuzie.
                            Așa s-a născut Academillion.
                            … din dorința de a crea o comunitate reală, în care să găsești sprijin, claritate și know-how de la investitori activi.
                            Un loc în care iei decizii informate, nu instinctive. Și unde randamentele tale nu sunt un noroc, ci o consecință a unei strategii clare și asumate. Dacă ar fi mers să înveți singur, ai fi avut deja rezultatele pe care le vrei. Dar adevărul e că încă ești aici, încă cauți soluții și încă plătești, doar că nu conștientizezi… plătești prin timp pierdut, oportunități ratate și bani aruncați pe decizii luate pe ghicite. Adevărul? Nimeni nu vine să te salveze. Ori intri în cercul celor care știu ce fac, ori accepți că vei rămâne exact unde ești acum. Alegerea e simplă. Doar să fii sincer cu tine când o faci.
                        </Typography>
                    </Box>
                
                    <Box
                        sx={{
                            flex: 1,
                            position: "relative",
                            display: "flex",
                            justifyContent: { xs: "center", xxl: "flex-end" }, 
                            maxWidth: { xs: "100%", xxl: "40%" }
                        }}
                    >
                    <Box
                        component="img"
                        src={placeholderImage}
                        alt="Discussion"
                        sx={{
                            position: 'relative',
                            width: { xs: "380px", xxl: "500px" },
                            borderRadius: "16px",
                            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                        }}
                    />
                    </Box>
                </Box> */}



                
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 6,
                        py: { xs: 4, xxl: 6 },
                    }}
                >
                    {sections.map((section, index) => {
                        const isReversed = index === 1;

                        return (
                        <Box
                            key={index}
                            sx={{
                            display: 'flex',
                            flexDirection: {
                                xs: 'column',
                                xxl: isReversed ? 'row-reverse' : 'row',
                            },
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 2,
                            }}
                        >
                            {/* Text Section */}
                            <Box
                            sx={{
                                flex: 1,
                                maxWidth: { xs: "100%", xxl: "60%" },
                                color: "#fff",
                                textAlign: { xs: "center", xxl: "left" },
                                mb: { xs: 4, xxl: 0 },
                            }}
                            >
                            <Typography
                                variant="h2"
                                sx={{
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: { xs: "20px", xxl: "36px" },
                                mb: { xs: 3, xxl: 6 },
                                }}
                            >
                                {section.title}
                            </Typography>

                            {section.paragraphs.map((text, i) => (
                                <Typography
                                key={i}
                                variant="subtitle2"
                                sx={{
                                    fontSize: { xs: "14px", xxl: "21px" },
                                    mb: 2,
                                }}
                                >
                                {text}
                                </Typography>
                            ))}
                            </Box>

                            {/* Image Section */}
                            <Box
                            sx={{
                                flex: 1,
                                display: "flex",
                                justifyContent: "center",
                                maxWidth: { xs: "100%", xxl: "40%" },
                                width: { xs: "380px", xxl: "500px" },
                            }}
                            >
                            <Box
                                component="img"
                                src={section.image}
                                alt={`Visual ${index + 1}`}
                                sx={{
                                width: { xs: "380px", xxl: "500px" },
                                borderRadius: "16px",
                                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                                }}
                            />
                            </Box>
                        </Box>
                        );
                    })}
                </Box>

            </Box>
        </Box>
        </>
    );
};

export default SolutionSection;